import { useQuery } from '@tanstack/react-query'
import { FaqCategoryItem, FaqCategoryListParams } from 'Modules'

import { AppAdmin } from 'api/app-admin'
import { logError } from 'utils/logger'

import { faqCategoryKeys } from './query-keys'

interface FaqCategoryListResult {
  results: FaqCategoryItem[]
  total: number
  maxCategories: number
}

const fetchFaqCategoryList = async (params: FaqCategoryListParams): Promise<FaqCategoryListResult> => {
  try {
    const res = await AppAdmin.getFaqCategoryList({
      search: params.search?.trim() || undefined,
      articleStatus: params.articleStatus || undefined,
      categoryVisibility: params.categoryVisibility || undefined,
    })
    const payload = res.data?.data
    return {
      results: payload?.results ?? [],
      total: payload?.total ?? 0,
      maxCategories: payload?.maxCategories ?? 20,
    }
  } catch (error) {
    logError('Error fetching FAQ categories:', error)
    return { results: [], total: 0, maxCategories: 20 }
  }
}

export const useFaqCategoryList = (params: FaqCategoryListParams = {}) => {
  const query = useQuery({
    queryKey: faqCategoryKeys.list(params),
    queryFn: () => fetchFaqCategoryList(params),
    gcTime: 30000,
  })

  return {
    items: query.data?.results ?? [],
    total: query.data?.total ?? 0,
    maxCategories: query.data?.maxCategories ?? 20,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    refetch: query.refetch,
  }
}
